import BaseDataProcessor from './baseDataProcessor';
import { humanizeTimeSpan } from '../../../../../utilities/dateTime';
import moment from 'moment-timezone';

export default class PrayingDataProcessor extends BaseDataProcessor {
  constructor(apiStatisticsData, interval) {
    super();

    this.apiStatisticsData = apiStatisticsData;
    this.interval = interval
  }

  get apiData() {
    return this.apiStatisticsData;
  }

  get data() {
    if (this.apiStatisticsData) {
      const { timePrayed, timePrayedDelta, timePrayedForPastors } = this.apiStatisticsData;
      return [
        { primaryText: humanizeTimeSpan(timePrayed), secondaryText: '' },
        this.deltaItem(timePrayedDelta),
        this.prayedForPastorsItem(timePrayedForPastors)
      ].filter(item => item);
    } else {
      return [];
    }
  }

  get chartData() {
    if (this.apiStatisticsData) {
      const { timeDistribution } = this.apiStatisticsData;
      const currentDate = moment(Date.now()).tz('UTC');

      return timeDistribution.map((item) => this.mapDataForChart(item, currentDate));
    } else {
      return [];
    }
  }

  mapDataForChart(item, currentDate) {
    const isBeforeToday = moment.unix(item.intervalStart).isSameOrBefore(currentDate);
    return { x: this.xValue(moment.unix(item.intervalStart)), y: isBeforeToday ? item.timePrayed : null };
  }

  get pointTooltip() {
    if(this.interval === 'all time') {
      return (datum) => `${datum.x}\nPrayed ${humanizeTimeSpan(datum.y)}`;
    } else {
      return (datum) => `Prayed ${humanizeTimeSpan(datum.y)}`;
    }
  }

  deltaItem(delta) {
    if (this.apiStatisticsData) {
      if(this.interval !== 'all time' ) {
        return {
          primaryText: this.decorateDeltaValue(delta, BaseDataProcessor.SIGN_TYPE_ARROW, false,
            (value) => humanizeTimeSpan(Math.abs(value))),
          secondaryText: this.decorateDeltaText(delta, this.interval)
        }
      } else {
        return null;
      }
    } else {
      return {};
    }
  }

  prayedForPastorsItem(timePrayedForPastors) {
    if(timePrayedForPastors) {
      return { primaryText: humanizeTimeSpan(timePrayedForPastors), secondaryText: 'prayed for pastors' }
    } else {
      return null;
    }
  }

  xValue(value) {
    if(this.interval === 'all time' ) {
      return value.format('MMM DD');
    } else if(this.interval === 'week') {
      return value.format('ddd');
    } else {
      return value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/statistics/common/dataProcessors/prayingDataProcessor.js